export default __webpack_public_path__ + "static/media/tech_stack.764d82eb.svg";